import * as React from 'react';
import { Heading } from '@grandvisionhq/elements';

/**
 *
 * @deprecated
 * On the Solutions v2 template, we are now using <SolutionsDetailsList />
 */ const SolutionsProductDetails = (props)=>{
    if (Object.values(props).every((productDetails)=>productDetails === ''
    )) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Heading, {
        variant: "subheading1"
    }, props.headerTitle), /*#__PURE__*/ React.createElement("ul", null, Object.keys(props).filter((el)=>el !== 'headerTitle'
    ).map((key)=>props[key] ? /*#__PURE__*/ React.createElement("li", {
            key: key
        }, props[key]) : null
    )));
};

export { SolutionsProductDetails as default };
//# sourceMappingURL=SolutionsProductDetails.js.map
